import { useState, useEffect, useCallback } from "react";
import { useGetProjectTariffQuery } from "../redux/api";

export const useLoadProjectTariff = (projectId: string) => {
    const [shouldFetch, setShouldFetch] = useState(false);
    const { data, isLoading, isError, refetch } = useGetProjectTariffQuery(
        { project_id: projectId },
        { skip: !shouldFetch, refetchOnMountOrArgChange: true }
    );

    useEffect(() => {
        if (shouldFetch) {
            refetch();
        }
    }, [shouldFetch, refetch]);

    useEffect(() => {
        if (!isLoading && data && !isError) {
            setShouldFetch(false);
        } else if (!isLoading && isError) {
            setShouldFetch(false);
        }
    }, [data, isError, isLoading]);

    const loadProjectTariff = useCallback(() => {
        setShouldFetch(true);
    }, []);

    return { loadProjectTariff, isLoading, data, isError };
};